import {
  IonCard,
  IonInput,
  IonItem,
  IonLabel,
  IonFooter,
  IonToolbar,
  useIonToast,
  IonButton,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useFirebase } from "../components/firebase-provider";
import PageLayout from "../components/layout";

const Profile: React.FC = () => {
  const [isSubmitting, setSubmitting] = useState(false);
  const [toast] = useIonToast();
  const { auth } = useFirebase();
  const user = auth.currentUser;

  const [userData, setUserData] = useState<any>({});
  useEffect(() => {
    if (user) {
      setUserData(user);
    }
  }, [user]);

  const handleChange = (el: any) => {
    setUserData({ ...userData, [el.target.name]: el.detail.value });
  };

  return (
    <PageLayout title="Profil">
      <IonCard>
        <IonItem>
          <IonLabel position="stacked">Nama</IonLabel>
          <IonInput
            disabled={isSubmitting}
            name="displayName"
            value={userData.displayName}
            onIonChange={handleChange}
          />
        </IonItem>

        <IonItem>
          <IonLabel position="stacked">Email</IonLabel>
          <IonInput name="email" value={userData.email} />
        </IonItem>

        <IonFooter>
          <IonToolbar>
            <IonButton
              disabled={isSubmitting || userData === user}
              onClick={async () => {
                setSubmitting(true);
                await user
                  .updateProfile(userData)
                  .then(() => {
                    toast({
                      message: "Profil berhasil diperbarui",
                      duration: 1000,
                      color: "sucsess",
                      position: "top",
                    });
                  })
                  .catch(() => {
                    toast({
                      message: "Profil gagal diperbarui",
                      duration: 1000,
                      color: "warning",
                      position: "top",
                    });
                  });
                setSubmitting(false);
              }}
            >
              Simpan
            </IonButton>
          </IonToolbar>
        </IonFooter>
      </IonCard>
    </PageLayout>
  );
};

export default Profile;
